import React from 'react'
import styled from 'styled-components'
import { ImageLoader } from '@usap/uicomponents'

const ArticleImageLoader = styled(ImageLoader)`
  width: 100%;
  height: auto;
`

// Extract image size from cloudinary link images if available (w_\d+)
// this is use for maintaining aspect-ratio of the image and avoids CLS
const extractImageSize = (src, x, fallback = 'auto') => {
  const matches = src.match(new RegExp(`${x}_(\\d+)`))
  return matches && matches[1] || fallback
}

const ArticleImage = ({src, ...props}) => {
  const height = extractImageSize(src, 'h', 'auto')
  const width = extractImageSize(src, 'w', '100%')

  return (
    <ArticleImageLoader
      height={height}
      width={width}
      src={src}
      {...props}
    />
  )
}

export default ArticleImage
